// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2rBq4","notes":"Notes_notes__1KKKO"};